if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
// ===== SAFE SOLD OUT CROSS FIX (DO NOT MODIFY ABOVE CODE) =====
document.addEventListener('DOMContentLoaded', function () {

  function applySoldOutCross() {
    const variantsScript = document.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    const groups = document.querySelectorAll('.product-form__input');

    groups.forEach((group, groupIndex) => {
      const radios = group.querySelectorAll('input[type="radio"]');

      radios.forEach((radio) => {
        const label = radio.nextElementSibling;
        if (!label) return;

        const testValue = radio.value;

        // get currently selected options
        const selectedValues = Array.from(groups).map((g, idx) => {
          const checked = g.querySelector('input[type="radio"]:checked');
          if (!checked) return null;
          return idx === groupIndex ? testValue : checked.value;
        });

        // find matching variant
        const match = variants.find(v => {
          if (!v.options) return false;
          return selectedValues.every((val, i) => {
            if (val === null) return true;
            return v.options[i] === val;
          });
        });

        // apply class
        if (match && match.available === false) {
          label.classList.add('is-soldout-line');
        } else {
          label.classList.remove('is-soldout-line');
        }
      });
    });
  }

  // run initially
  setTimeout(applySoldOutCross, 200);

  // run on variant change
  document.addEventListener('change', () => {
    setTimeout(applySoldOutCross, 200);
  });

  // observe DOM changes (Shopify updates)
  const observer = new MutationObserver(() => {
    applySoldOutCross();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

});